// Portal
import Portal from "../pages/Portal/index";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

const authProtectedRoutes = [
  //   { path: "/dashboard", component: Dashboard },
  //   // //profile
  //   { path: "/profile", component: UserProfile },
  //   // User management
  //   // { path: "/user-management/list", component: ListUser },
  //   // { path: "/user-management/create", component: CreateUser },
  //   // General info - Business Unit
  //   { path: "/business-unit-manager/list", component: ListBusinessUnit },
  //   { path: "/business-unit-manager/create", component: CreateBusinessUnit },
  //   // General info - VAT
  //   { path: "/vat-manager/list", component: ListVATManager },
  //   // General info - Currency
  //   { path: "/currency-manager/list", component: ListCurrencyManager },
  //   { path: "/currency-manager/create", component: CreateCurrencyManager },
  //   // General info - Payment method
  //   { path: "/payment-method-manager/list", component: ListPaymentMethodManager },
  //   {
  //     path: "/payment-method-manager/create",
  //     component: CreatePaymentMethodManager,
  //   },
  //   // General info - Invoice Symbol
  //   { path: "/invoice-symbol-manager/list", component: ListInvoiceSymbol },
  //   { path: "/product/list", component: ListProduct },
  //   { path: "/customer/list", component: ListCustomer },
  //   // Notification management
  //   { path: "/notification-management/list", component: ListNotification },
  //   { path: "/notification-management/create", component: CreateNotification },
  //   // this route should be at the end of all other routes
  //   // eslint-disable-next-line react/display-name
  //   { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  //   // Thông báo từ TCT
  //   { path: "/notice-from-TCT", component: ListDataNoticeFromTCT },
  //   // Lập bảng tổng hợp dữ liệu hóa đơn
  //   { path: "/report/create-invoice-cycles", component: CreateData },
  //   { path: "/report/list-invoice-cycles", component: ListData },
  //   // Lập bảng kê hóa đơn
  //   { path: "/report/create-report-invoice", component: CreateReportInvoice },
  //   { path: "/report/list-report-invoice", component: ListReportInvoice },
  //   // Lập bảng kê tình hình sử dụng hóa đơn
  //   {
  //     path: "/report/create-report-invoice-use",
  //     component: CreateReportInvoiceUse,
  //   },
  //   { path: "/report/list-report-invoice-use", component: ListReportInvoiceUse },
  //   // Lập bảng kê hóa đơn tổng
  //   {
  //     path: "/report/create-report-invoice-total",
  //     component: CreateReportInvoiceTotal,
  //   },
  //   {
  //     path: "/report/list-report-invoice-total",
  //     component: ListReportInvoiceTotal,
  //   },
  //   // Lập Bảng tổng hợp thông báo gửi CQT
  //   {
  //     path: "/report/create-report-invoice-error",
  //     component: CreateReportInvoiceError,
  //   },
  //   {
  //     path: "/report/list-report-invoice-error",
  //     component: ListReportInvoiceError,
  //   },
  //   // Đăng ký/ Ủy quyền/ Đề nghị
  //   { path: "/data-format/registry-invoice", component: ListDataRegistryInvoice },
  //   {
  //     path: "/data-format/registry-delegate",
  //     component: ListDataRegistryDelegate,
  //   },
  //   {
  //     path: "/data-format/request-invoice-code",
  //     component: ListDataRequestInvoiceCode,
  //   },
  //   // Lập hóa đơn
  //   { path: "/invoice/create", component: CreateInvoice },
  //   { path: "/invoice/new", component: ListNewInvoice },
  //   { path: "/invoice/release", component: ListReleaseInvoice },
  //   { path: "/invoice/wait-release", component: ListWaitReleaseInvoice },
  //   { path: "/invoice/all", component: ListAllInvoice },
  //   { path: "/invoice/cancel", component: ListCancel },
  //   { path: "/invoice/replace", component: ListReplace },
  //   { path: "/invoice/adjust", component: ListAdjust },
  //   {
  //     path: "/invoice/las-pulse",
  //     component: ListPulseLas,
  //   },
  //   {
  //     path: "/invoice/:id",
  //     component: DetailInvoicePage,
  //   },
  //   // Dev-test
  //   { path: "/invoice/replace-dev", component: ListReplaceOld },
  //   { path: "/invoice/adjust-dev", component: ListAdjustOld },
  //   // Phát hành hóa đơn tem,vé
  //   {
  //     path: "/issue-invoice-tickets",
  //     component: ListInvoiceTickets,
  //   },
  //   // Hóa đơn sai sót
  //   {
  //     path: "/error-invoices",
  //     component: ListDataErrorInvoice,
  //   },
  //   {
  //     path: "/error-invoices/create",
  //     component: CreateErrorInvoice,
  //   },
  //   // phiếu xuất kho kiêm vận chuyển nội bộ
  //   {
  //     path: "/invoice-warehouses",
  //     component: ListInvoiceWareHouses,
  //   },
  //   // phiếu xuất kho gửi bán đại lý
  //   {
  //     path: "/invoice-warehouses-agency",
  //     component: ListInvoiceWareHousesAgency,
  //   },
  //   // Danh sách hóa đơn tổng
  //   { path: "/invoice-total", component: CreateInvoiceTotal },
  //   {
  //     path: "/invoice-templates",
  //     component: ListInvoiceTemplates,
  //   },
  //   {
  //     path: "/invoice-templates/create/select-template",
  //     component: InvoiceTemplateSelection,
  //   },
  //   {
  //     path: "/invoice-templates/create",
  //     component: InvoiceTemplateEditor,
  //   },
  //   {
  //     path: "/invoice-templates/:templateId",
  //     component: InvoiceTemplateEditor,
  //   },
  //   {
  //     path: "/business-unit-manager/list/create",
  //     component: BusinessUnitDetail,
  //   },
  //   {
  //     path: "/business-unit-manager/list/:businessId",
  //     component: BusinessUnitDetail,
  //   },
  //   {
  //     path: "/business-email-templates",
  //     component: BusinessEmailTemplateList,
  //   },
  //   {
  //     path: "/business-email-templates/:action",
  //     component: BusinessEmailTemplateDetails,
  //   },
  //   {
  //     path: "/business-email-templates/:action/:id",
  //     component: BusinessEmailTemplateDetails,
  //   },
  //   { path: "/change-password", component: ChangePassword, isNoneLayout: true },
  //   // Lập hóa đơn theo lô
  //   { path: "/invoice-campaign", component: ListDataCampaign },
  //   // Hóa đơn treo / lỗi truyền nhận
  //   { path: "/invoice-error-tct", component: ListErrorTCT },
];

const publicRoutes = [
  //   { path: "/logout", component: Logout },
  //   { path: "/login", component: Login },
  //   { path: "/forgot-password", component: ForgetPwd },
  //   { path: "/register", component: Register },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/", component: Portal },
];

export { authProtectedRoutes, publicRoutes };
